
































import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import {
  HisInformationItemSelectDialog,
  EditableFormatSummaryTreeSelectDialog,
  EditableFormatSummarySelectDialog,
  HisInformationTypeItemSelectDialog,
  UserDefinedInformationSelectDialog,
  LineGraphItemEditDialog,
  TextJoinItemEditDialog,
  ComboOptionEditDialog,
  NamedObjectsSelectDialog,
  RollOptionEditDialog,
  ScriptPathEditDialog,
  FilePathEditDialog,
  TableSizeEditDialog,
  FormatObjectSelectDialog,
  FormatObjectSingleSelectDialog,
  DateCalculateEditDialog,
  DateDurationSelectDialog,
  BarcodeItemEditDialog,
  DateComparisonExpressionEditDialog,
  CalculationExpressionEditDialog,
  CalculationConditionalExpressionContentEditDialog,
  CopyLinkedTextsDialog,
  CscanSettingSelectDialog,
  BackgroundImageSelectDialog,
  ConditionalExpressionContentEditDialog,
  QuestionnaireChildrenSelectDialog,
  QuestionnaireGlossaryItemSelectDialog,
} from "./dialogs";
import { ITreeSource, FormatTreeSource } from "../../../selectors/trees/sources";
import { EditableFormatSummary } from "../../../../../domain/editableFormat";


@Component({
  components: {
    HisInformationItemSelectDialog,
    EditableFormatSummaryTreeSelectDialog,
    EditableFormatSummarySelectDialog,
    HisInformationTypeItemSelectDialog,
    UserDefinedInformationSelectDialog,
    LineGraphItemEditDialog,
    TextJoinItemEditDialog,
    ComboOptionEditDialog,
    NamedObjectsSelectDialog,
    RollOptionEditDialog,
    ScriptPathEditDialog,
    FilePathEditDialog,
    TableSizeEditDialog,
    FormatObjectSelectDialog,
    FormatObjectSingleSelectDialog,
    DateCalculateEditDialog,
    DateDurationSelectDialog,
    BarcodeItemEditDialog,
    DateComparisonExpressionEditDialog,
    CalculationExpressionEditDialog,
    CalculationConditionalExpressionContentEditDialog,
    CopyLinkedTextsDialog,
    CscanSettingSelectDialog,
    BackgroundImageSelectDialog,
    ConditionalExpressionContentEditDialog,
    QuestionnaireChildrenSelectDialog,
    QuestionnaireGlossaryItemSelectDialog,
  }
})
export default class CommonDialogsContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  $refs!: {
    hisInformationItemSelectDialog: HisInformationItemSelectDialog,
    treeSelectDialog: EditableFormatSummaryTreeSelectDialog,
    formatSelectDialog: EditableFormatSummarySelectDialog,
    hisInformationTypeItemSelectDialog: HisInformationTypeItemSelectDialog,
    userDefinedInformationSelectDialog: UserDefinedInformationSelectDialog,
    lineGraphItemEditDialog: LineGraphItemEditDialog,
    textJoinItemEditDialog: TextJoinItemEditDialog,
    comboOptionEditDialog: ComboOptionEditDialog,
    namedObjectsSelectDialog: NamedObjectsSelectDialog,
    rollOptionEditDialog: RollOptionEditDialog,
    scriptPathEditDialog: ScriptPathEditDialog,
    filePathEditDialog: FilePathEditDialog,
    tableSizeEditDialog: TableSizeEditDialog,
    formatObjectSelectDialog: FormatObjectSelectDialog,
    formatObjectSingleSelectDialog: FormatObjectSingleSelectDialog,
    dateCalculateEditDialog: DateCalculateEditDialog,
    dateDurationSelectDialog: DateDurationSelectDialog,
    barcodeItemEditDialog: BarcodeItemEditDialog,
    dateComparisonExpressionEditDialog: DateComparisonExpressionEditDialog,
    calculationExpressionEditDialog: CalculationExpressionEditDialog,
    calculationConditionalExpressionContentEditDialog: CalculationConditionalExpressionContentEditDialog,
    copyLinkedTextsDialog: CopyLinkedTextsDialog,
    cscanSettingSelectDialog: CscanSettingSelectDialog,
    backgroundImageSelectDialog: BackgroundImageSelectDialog,
    conditionalExpressionContentEditDialog: ConditionalExpressionContentEditDialog,
    questionnaireChildrenSelectDialog: QuestionnaireChildrenSelectDialog,
    questionnaireGlossaryItemSelectDialog: QuestionnaireGlossaryItemSelectDialog,
  };

  treeSource: ITreeSource<number, EditableFormatSummary> = new FormatTreeSource();

  getHisInformationItemSelectDialog(): HisInformationItemSelectDialog {
    return this.$refs.hisInformationItemSelectDialog;
  }

  getTreeSelectDialog(): EditableFormatSummaryTreeSelectDialog {
    return this.$refs.treeSelectDialog;
  }

  getFormatSelectDialog(): EditableFormatSummarySelectDialog {
    return this.$refs.formatSelectDialog;
  }

  gethisInformationTypeItemSelectDialog(): HisInformationTypeItemSelectDialog {
    return this.$refs.hisInformationTypeItemSelectDialog;
  }

  getUserDefinedInformationSelectDialog(): UserDefinedInformationSelectDialog {
    return this.$refs.userDefinedInformationSelectDialog;
  }

  getLineGraphItemEditDialog(): LineGraphItemEditDialog {
    return this.$refs.lineGraphItemEditDialog;
  }

  getTextJoinItemEditDialog(): TextJoinItemEditDialog {
    return this.$refs.textJoinItemEditDialog;
  }

  getComboOptionEditDialog(): ComboOptionEditDialog {
    return this.$refs.comboOptionEditDialog;
  }

  getNamedObjectsSelectDialog(): NamedObjectsSelectDialog {
    return this.$refs.namedObjectsSelectDialog;
  }

  getRollOptionEditDialog(): RollOptionEditDialog {
    return this.$refs.rollOptionEditDialog;
  }

  getScriptPathEditDialog(): ScriptPathEditDialog {
    return this.$refs.scriptPathEditDialog;
  }

  getFilePathEditDialog(): FilePathEditDialog {
    return this.$refs.filePathEditDialog;
  }

  getTableSizeEditDialog(): TableSizeEditDialog {
    return this.$refs.tableSizeEditDialog;
  }

  getFormatObjectSelectDialog(): FormatObjectSelectDialog {
    return this.$refs.formatObjectSelectDialog;
  }

  getFormatObjectSingleSelectDialog(): FormatObjectSingleSelectDialog {
    return this.$refs.formatObjectSingleSelectDialog;
  }

  getDateCalculateEditDialog(): DateCalculateEditDialog {
    return this.$refs.dateCalculateEditDialog;
  }

  getDateDurationSelectDialog(): DateDurationSelectDialog {
    return this.$refs.dateDurationSelectDialog;
  }

  getBarcodeItemEditDialog(): BarcodeItemEditDialog {
    return this.$refs.barcodeItemEditDialog;
  }

  getDateComparisonExpressionEditDialog(): DateComparisonExpressionEditDialog {
    return this.$refs.dateComparisonExpressionEditDialog;
  }

  getCalculationExpressionEditDialog(): CalculationExpressionEditDialog {
    return this.$refs.calculationExpressionEditDialog;
  }

  getCalculationConditionalExpressionContentEditDialog(): CalculationConditionalExpressionContentEditDialog {
    return this.$refs.calculationConditionalExpressionContentEditDialog;
  }

  getCopyLinkedTextsDialog(): CopyLinkedTextsDialog {
    return this.$refs.copyLinkedTextsDialog;
  }

  getCscanSettingSelectDialog(): CscanSettingSelectDialog {
    return this.$refs.cscanSettingSelectDialog;
  }

  getBackgroundImageSelectDialog(): BackgroundImageSelectDialog {
    return this.$refs.backgroundImageSelectDialog;
  }

  getConditionalExpressionContentEditDialog(): ConditionalExpressionContentEditDialog {
    return this.$refs.conditionalExpressionContentEditDialog;
  }

  getQuestionnaireChildrenSelectDialog(): QuestionnaireChildrenSelectDialog {
    return this.$refs.questionnaireChildrenSelectDialog;
  }

  getQuestionnaireGlossaryItemSelectDialog(): QuestionnaireGlossaryItemSelectDialog {
    return this.$refs.questionnaireGlossaryItemSelectDialog;
  }
}
